import { GeoLevel } from '@sbt-web/network/types';

const TuttaItalia = {
    id: '0',
    friendlyName: 'italia',
    label: 'Regione',
    level: 0,
    uri: '/geo/region',
    value: 'Tutta Italia',
};
function getGeoLevel(geo, searchNearRegions) {
    if (!geo?.region?.value)
        return null;
    if (geo.town) {
        return GeoLevel.Town;
    }
    else if (geo.city) {
        return GeoLevel.City;
    }
    else if (!searchNearRegions && geo.region.id != TuttaItalia.id) {
        return GeoLevel.Region;
    }
    else if (searchNearRegions && geo.region.id != TuttaItalia.id) {
        return GeoLevel.RegionAndNearRegions;
    }
    return GeoLevel.Italia;
}
/**
 * Returns a geo label to be used when describing a specific geo entry
 *
 * e.g. 'Milano (MI)', 'Milano e provincia', 'Lombardia e regioni vicine'
 */
function getLabelFromGeo(geo, searchNearRegions) {
    const geoLevel = getGeoLevel(geo, searchNearRegions);
    switch (geoLevel) {
        case GeoLevel.Town:
            return `${geo.town?.value} ${geo.city?.shortName ? `(${geo.city?.shortName})` : ''}`;
        case GeoLevel.City:
            return `${geo.city?.value} e provincia`;
        case GeoLevel.Region:
            return `${geo.region?.value} regione`;
        case GeoLevel.RegionAndNearRegions:
            return `${geo.region?.value} e regioni vicine`;
        case GeoLevel.Italia:
            return geo.region.value;
        default:
            return '';
    }
}
/**
 * Returns the inclusion label ("a" or "in") based on the GeoLevel
 *
 * e.g. Annunci _a_ Milano, Annunci _in_ Lombardia
 */
function getGeoInclusionLabel(level) {
    if (level === GeoLevel.Town || level === GeoLevel.City) {
        return 'a';
    }
    return 'in';
}

export { TuttaItalia, getGeoInclusionLabel, getGeoLevel, getLabelFromGeo };
//# sourceMappingURL=index.js.map
